/* GreenGoing "Min bil" (Webbler, 2026-09)
   - Bilen gemmes kun i browseren (localStorage 'gg_min_bil').
   - Intet filtreres automatisk. Produktsiden viser pasform; listesiden FORESLÅR Shopifys eget filter. */
(() => {
  const KEY = 'gg_min_bil';
  const EVT = 'gg:bil-aendret';
  const MIN_DAEKNING = 0.2;   // se GgBilFilter
  const json = (id) => { try { return JSON.parse(document.getElementById(id)?.textContent || 'null'); } catch (e) { return null; } };
  const T = json('gg-min-bil-tekster') || {};
  const DATA = json('gg-bilmodeller') || [];
  const fmt = (s, v) => String(s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => (v[k] ?? ''));
  const numId = (id) => String(id || '').replace(/\D/g, '');   // gid eller tal → samme nøgle

  const hent = () => { try { const b = JSON.parse(localStorage.getItem(KEY) || 'null'); return b && b.id ? b : null; } catch (e) { return null; } };
  const gem = (bil) => {
    try { bil ? localStorage.setItem(KEY, JSON.stringify(bil)) : localStorage.removeItem(KEY); } catch (e) { /* privat vindue */ }
    document.dispatchEvent(new CustomEvent(EVT, { detail: bil }));
  };

  /* ---------- Vælger ---------- */
  const dialog = document.getElementById('gg-min-bil-dialog');
  const selM = document.getElementById('gg-bil-maerke');
  const selMod = document.getElementById('gg-bil-model');
  const btnGem = document.getElementById('gg-bil-gem');
  const btnFjern = document.getElementById('gg-bil-fjern');

  if (selM && !selM.dataset.klar) {
    selM.dataset.klar = '1';
    DATA.forEach((g, i) => selM.add(new Option(g.m, String(i))));
    const fyldModeller = (valgtId) => {
      const g = DATA[Number(selM.value)];
      selMod.length = 1;
      selMod.disabled = !g;
      if (g) g.modeller.forEach((m) => selMod.add(new Option(m.n, m.id, false, m.id === valgtId)));
      btnGem.disabled = !selMod.value;
    };
    selM.addEventListener('change', () => fyldModeller());
    selMod.addEventListener('change', () => { btnGem.disabled = !selMod.value; });
    dialog.addEventListener('close', () => {
      if (dialog.returnValue === 'gem' && selMod.value) {
        const g = DATA[Number(selM.value)];
        const m = g.modeller.find((x) => x.id === selMod.value);
        gem({ v: 1, id: m.id, h: m.h, n: m.n, m: g.m, gen: null });
      } else if (dialog.returnValue === 'fjern') {
        gem(null);
      }
      dialog._opener?.focus();
    });
    dialog._aabn = (opener) => {
      const bil = hent();
      const gi = bil ? DATA.findIndex((g) => g.m === bil.m) : -1;
      selM.value = gi >= 0 ? String(gi) : '';
      fyldModeller(bil?.id);
      btnFjern.hidden = !bil;
      dialog._opener = opener;
      dialog.returnValue = '';
      dialog.showModal();
      selM.focus();
    };
  }

  class GgMinBil extends HTMLElement {
    connectedCallback() {
      this.navn = this.querySelector('[data-gg-bil-navn]');
      this.knap = this.querySelector('button');
      this.knap.addEventListener('click', () => {
        // I mobilmenuen: luk den med temaets egen lukkeknap og åbn først dialogen, når den er helt lukket.
        // (Temaets onFocusOut kalder ellers closeMenuDrawer() uden event og kaster en fejl.)
        const drawer = this.closest('details[open]');
        if (!drawer) { dialog?._aabn(this.knap); return; }
        drawer.querySelector('.close-menu-js')?.click();
        const start = Date.now();
        const vent = () => {
          if (!drawer.hasAttribute('open') || Date.now() - start > 1200) {
            dialog?._aabn(drawer.querySelector('summary') || this.knap);
          } else {
            setTimeout(vent, 50);
          }
        };
        setTimeout(vent, 50);
      });
      this.vis = () => {
        const bil = hent();
        this.navn.textContent = bil ? bil.n : T.vaelg;
        this.classList.toggle('gg-min-bil--valgt', !!bil);
      };
      document.addEventListener(EVT, this.vis);
      this.vis();
    }
    disconnectedCallback() { document.removeEventListener(EVT, this.vis); }
  }

  /* ---------- Produktside ---------- */
  class GgPasform extends HTMLElement {
    connectedCallback() {
      try { this.modeller = JSON.parse(this.querySelector('script').textContent); } catch (e) { this.modeller = []; }
      this.tekst = this.querySelector('.gg-pasform__tekst');
      this.vis = () => {
        const bil = hent();
        let tilstand = null, txt = '';
        // Kun positiv besked: "passer ikke" og "ikke angivet" vises ikke (beslutning 2026-09-17).
        if (bil && this.modeller.some((m) => numId(m.id) === numId(bil.id))) {
          tilstand = 'ok';
          txt = fmt(T.passer, { bil: bil.n });
        }
        this.hidden = !tilstand;
        this.dataset.tilstand = tilstand || '';
        this.tekst.textContent = txt;
      };
      document.addEventListener(EVT, this.vis);
      this.vis();
    }
    disconnectedCallback() { document.removeEventListener(EVT, this.vis); }
  }

  /* ---------- Listeside ---------- */
  class GgBilFilter extends HTMLElement {
    connectedCallback() { this.init(); }
    init() {
      try { this.vaerdier = JSON.parse(this.querySelector('script').textContent); } catch (e) { this.vaerdier = []; }
      this.tekst = this.querySelector('.gg-bil-filter__tekst');
      this.link = this.querySelector('.gg-bil-filter__link');
      this.vis = () => {
        const bil = hent();
        const total = Number(this.dataset.total) || 0;
        const v = bil && this.vaerdier.find((x) => numId(x.v) === numId(bil.id));
        let txt = '', link = null;
        if (!bil) { this.hidden = true; return; }
        // Kun på lister hvor pasform betyder noget: mindst 20 % pasformsdata (sum af filterværdier / antal varer).
        // Et filter kunden selv har slået til vises altid, så det aldrig er skjult, at listen er filtreret.
        const dækning = this.vaerdier.reduce((a, x) => a + x.c, 0) / Math.max(total, 1);
        if (!(v && v.a) && dækning < MIN_DAEKNING) { this.hidden = true; return; }
        if (v && v.a) {                       // filteret er slået til → sig det tydeligt
          txt = fmt(T.filtreret, { bil: bil.n, antal: this.dataset.vist, total });
          link = { href: v.rm, tekst: T.vis_alle };
        } else if (v && v.c >= total) {       // alt i kollektionen passer
          txt = fmt(T.alle_passer, { bil: bil.n });
        } else if (v && v.c > 0) {            // forslag, kunden vælger selv
          txt = fmt(T.forslag, { antal: v.c, total, bil: bil.n });
          link = { href: v.add, tekst: T.vis_kun };
        } else {                              // intet bekræftet → vis alt, forklar
          txt = fmt(T.ingen, { bil: bil.n });
        }
        this.tekst.textContent = txt;
        this.link.hidden = !link;
        if (link) { this.link.href = link.href; this.link.textContent = link.tekst; }
        this.dataset.aktiv = v && v.a ? 'true' : 'false';
        this.hidden = false;
      };
      document.addEventListener(EVT, this.vis);
      this.vis();
    }
    disconnectedCallback() { document.removeEventListener(EVT, this.vis); }
  }

  if (!customElements.get('gg-min-bil')) customElements.define('gg-min-bil', GgMinBil);
  if (!customElements.get('gg-pasform')) customElements.define('gg-pasform', GgPasform);
  if (!customElements.get('gg-bil-filter')) customElements.define('gg-bil-filter', GgBilFilter);
})();
